module.exports = __webpack_public_path__ + "img/ico049.a4bc84df.svg";